<template><div class="mt-5 opacity-50" v-html="help"></div></template>
<script>
export default {
  props: ["help"],
};
</script>
